interface SnackbarConfig {
  anchorOrigin: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  maxSnack: number;
  style: Record<string, string>;
  autoHideDuration: number;
}

export const snackBarConfig: SnackbarConfig = {
  maxSnack: 5,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  style: {
    width: '200px',
  },
  autoHideDuration: 3000,
};
